/* Rocket Yard homepage repair.
 * The previous theme's Shopify video_tag markup remains server-rendered.
 * Scroll seeking enhances an already loaded video; it never gates page content.
 * No wheel interception, stage snapping, autoplay or replacement media URLs.
 */
(function () {
  'use strict';
  if (window.RYHomepageFilm) { window.RYHomepageFilm.boot(); return; }
  var instances = new Map();
  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function number(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function create(root) {
    var hero = root.querySelector('[data-ry-hero-section]');
    if (!hero) return function () {};
    var sticky = hero.querySelector('.ry-scroll-hero__sticky');
    var videos = Array.from(hero.querySelectorAll('video.ry-hero-video'));
    var bar = hero.querySelector('[data-ry-film-progress]');
    var status = hero.querySelector('[data-ry-film-status]');
    var skip = hero.querySelector('[data-ry-skip-film]');
    var outcomeHeading = root.querySelector('.ry-service-outcome-lines');
    var outcomeStory = root.querySelector('[data-ry-outcome-story]');
    var outcomeLines = outcomeHeading ? Array.from(outcomeHeading.querySelectorAll('span')) : [];
    var inlineZoomSection = root.querySelector('[data-ry-scroll-zoom]');
    var inlineZoomImage = inlineZoomSection ? inlineZoomSection.querySelector('.ry-home-inline-image__media') : null;
    var mobile = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var video = null;
    var wantedTime = 0;
    var frame = 0;
    var seekFrame = 0;
    var disposed = false;
    var loadTimer = 0;
    var removers = [];
    var observer = null;
    var travel = clamp(number(hero.dataset.ryScrollDistance, 3600), 2000, 10000);
    var start = clamp(number(hero.dataset.ryVideoStart, 0), 0, 0.5);
    var end = clamp(number(hero.dataset.ryVideoEnd, 1), start + 0.05, 1);
    hero.style.setProperty('--ry-film-travel', travel + 'px');

    function on(target, event, fn, options) {
      target.addEventListener(event, fn, options);
      removers.push(function () { target.removeEventListener(event, fn, options); });
    }
    function onQuery(query, fn) {
      if (query.addEventListener) on(query, 'change', fn);
      else {
        query.addListener(fn);
        removers.push(function () { query.removeListener(fn); });
      }
    }
    function say(message) { if (status) status.textContent = message; }
    function validDuration() {
      return video && Number.isFinite(video.duration) && video.duration > 0;
    }
    function goToMessage() {
      var message = root.querySelector('#problem');
      if (!message) return;
      var html = document.documentElement;
      var previous = html.style.getPropertyValue('scroll-behavior');
      var priority = html.style.getPropertyPriority('scroll-behavior');
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      message.scrollIntoView({ behavior: 'auto', block: 'start' });
      message.setAttribute('tabindex', '-1');
      message.focus({ preventScroll: true });
      if (previous) html.style.setProperty('scroll-behavior', previous, priority);
      else html.style.removeProperty('scroll-behavior');
    }
    function shortenFilm() {
      var rect = hero.getBoundingClientRect();
      var wasInside = hero.classList.contains('is-ry-film-ready') &&
        rect.top < -sticky.offsetHeight && rect.bottom > 0;
      hero.classList.remove('is-ry-film-ready');
      if (wasInside) goToMessage();
    }
    function enableWhenReady() {
      if (disposed || reduce.matches || !validDuration() || video.error ||
          video.readyState < 2 || video.seeking) return;
      var rect = hero.getBoundingClientRect();
      // Do not suddenly insert a long scroll section above somebody reading the page.
      if (!hero.classList.contains('is-ry-film-ready') && rect.bottom <= 0) return;
      hero.classList.add('is-ry-film-ready');
      hero.classList.remove('is-ry-film-failed');
      clearTimeout(loadTimer);
    }
    function flushSeek() {
      seekFrame = 0;
      if (disposed || !validDuration() || video.readyState < 1 || video.seeking || video.error) return;
      var t = clamp(wantedTime, 0, Math.max(0, video.duration - 0.03));
      if (Math.abs(video.currentTime - t) < 0.04) return;
      try { video.currentTime = t; } catch (error) {
        // Retry when this native media element reports loadeddata/canplay.
      }
    }
    function queueSeek() {
      if (!disposed && !seekFrame) seekFrame = window.requestAnimationFrame(flushSeek);
    }
    function updateOutcomeReveal() {
      if (!outcomeHeading || !outcomeStory || !outcomeLines.length || reduce.matches) return;
      var rect = outcomeStory.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var travel = Math.max(1, rect.height - vh);
      var progress = clamp(-rect.top / travel, 0, 0.9999);
      var activeIndex = Math.min(outcomeLines.length - 1, Math.floor(progress * outcomeLines.length));
      outcomeLines.forEach(function (line, index) {
        line.classList.toggle('is-visible', index === activeIndex);
        line.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      });
    }
    function updateInlineZoom() {
      if (!inlineZoomSection || !inlineZoomImage) return;
      if (reduce.matches) {
        inlineZoomImage.style.setProperty('--ry-inline-zoom', '1');
        return;
      }
      var rect = inlineZoomSection.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var total = Math.max(1, vh + rect.height);
      var progress = clamp((vh - rect.top) / total, 0, 1);
      var scale = 1 + (progress * 0.12);
      inlineZoomImage.style.setProperty('--ry-inline-zoom', scale.toFixed(4));
    }
    function update() {
      frame = 0;
      if (disposed || !root.isConnected) return;
      enableWhenReady();
      var distance = Math.max(1, hero.offsetHeight - sticky.offsetHeight);
      var progress = hero.classList.contains('is-ry-film-ready')
        ? clamp(-hero.getBoundingClientRect().top / distance, 0, 1) : 0;
      if (bar) bar.style.transform = 'scaleX(' + progress.toFixed(5) + ')';
      if (validDuration()) {
        wantedTime = video.duration * (start + (end - start) * progress);
        queueSeek();
      }
      updateOutcomeReveal();
      updateInlineZoom();
    }
    function schedule() {
      if (!disposed && !frame) frame = window.requestAnimationFrame(update);
    }
    function mediaReady(event) {
      if (event && event.currentTarget !== video) return;
      if (!validDuration()) return;
      video.pause();
      enableWhenReady();
      update();
    }
    function mediaError(event) {
      if (event && event.currentTarget !== video) return;
      clearTimeout(loadTimer);
      shortenFilm();
      hero.classList.add('is-ry-film-failed');
      say('Continue below to explore Rocket Yard');
      schedule();
    }
    function chooseVideo() {
      if (disposed) return;
      var selected = hero.querySelector(mobile.matches
        ? '.ry-hero-video--mobile' : '.ry-hero-video--desktop') || videos[0];
      videos.forEach(function (item) {
        item.pause();
        item.muted = true;
        item.defaultMuted = true;
        item.playsInline = true;
        item.removeAttribute('autoplay');
        item.removeAttribute('loop');
        item.classList.toggle('ry-film-native-active', item === selected);
      });
      if (!selected) {
        video = null;
        shortenFilm();
        say('Explore Rocket Yard below');
        return;
      }
      if (video === selected) { schedule(); return; }
      video = selected;
      // Both desktop and mobile films are rendered with preload="none" so the
      // browser only downloads the one that matches the current viewport.
      video.preload = 'auto';
      hero.classList.remove('is-ry-film-failed');
      // Keep the native <source> output. Prefer one of its real MP4 URLs for seeking,
      // rather than depending on a custom Liquid sources filter or data-* URL.
      var mp4 = Array.from(video.querySelectorAll('source')).find(function (source) {
        return source.type === 'video/mp4' || /\.mp4(?:[?#]|$)/i.test(source.src);
      });
      if (mp4 && video.currentSrc !== mp4.src && video.src !== mp4.src) {
        video.src = mp4.src;
        video.load();
      } else if (video.readyState === 0 && video.networkState !== 2) {
        video.load();
      }
      clearTimeout(loadTimer);
      loadTimer = window.setTimeout(function () {
        if (video && video.readyState < 2 && !disposed) {
          shortenFilm();
          say('Film loading. You can continue below.');
        }
      }, 12000);
      if (reduce.matches) say('Explore Rocket Yard below');
      if (validDuration()) mediaReady();
      schedule();
    }

    videos.forEach(function (item) {
      ['loadedmetadata', 'loadeddata', 'canplay', 'seeked'].forEach(function (event) {
        on(item, event, mediaReady);
      });
      on(item, 'error', mediaError);
      on(item, 'play', function () { item.pause(); });
    });
    on(window, 'scroll', schedule, { passive: true });
    on(window, 'resize', schedule, { passive: true });
    on(window, 'pageshow', schedule);
    onQuery(mobile, chooseVideo);
    onQuery(reduce, function () {
      if (reduce.matches) {
        shortenFilm();
        say('Explore Rocket Yard below');
        root.classList.remove('ry-outcome-scroll-enabled');
        outcomeLines.forEach(function (line) { line.classList.add('is-visible'); line.removeAttribute('aria-hidden'); });
        if (inlineZoomImage) inlineZoomImage.style.setProperty('--ry-inline-zoom', '1');
      } else if (outcomeHeading && outcomeStory && outcomeLines.length) {
        root.classList.add('ry-outcome-scroll-enabled');
        updateOutcomeReveal();
      }
      schedule();
    });
    if (skip) on(skip, 'click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      goToMessage();
      schedule();
    }, true);

    if (outcomeHeading && outcomeLines.length && !reduce.matches) {
      root.classList.add('ry-outcome-scroll-enabled');
      updateOutcomeReveal();
    }

    // Existing lower-page reveals do not control the film introduction.
    var reveals = root.querySelectorAll('[data-ry-reveal]');
    if ('IntersectionObserver' in window && !reduce.matches) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });
      reveals.forEach(function (element) { observer.observe(element); });
      root.classList.add('ry-home-motion');
    } else {
      reveals.forEach(function (element) { element.classList.add('is-visible'); });
    }
    chooseVideo();
    return function () {
      disposed = true;
      window.cancelAnimationFrame(frame);
      window.cancelAnimationFrame(seekFrame);
      clearTimeout(loadTimer);
      removers.forEach(function (remove) { remove(); });
      if (observer) observer.disconnect();
      videos.forEach(function (item) { item.pause(); });
      hero.classList.remove('is-ry-film-ready');
      root.classList.remove('ry-home-motion');
      root.classList.remove('ry-outcome-scroll-enabled');
    };
  }

  function boot() {
    instances.forEach(function (destroy, root) {
      if (!root.isConnected) { destroy(); instances.delete(root); }
    });
    document.querySelectorAll('.ry-redesign-home').forEach(function (root) {
      if (!instances.has(root)) instances.set(root, create(root));
    });
  }
  window.RYHomepageFilm = { boot: boot, version: 'native-restore-2026-09-10' };
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) {
      if (event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
